export default {"src":"/_next/static/image/public/logos/binance-logo.2ceb91f5fd6f601cbaa07f6ec8478192.svg","height":127,"width":128};